import imagesLoaded from 'imagesloaded'
import { debounce } from './helpers'
import infiniteScroll from './infiniteScroll'
import lightbox from './lightbox'

const MAIN_FEED_SELECTOR =
  '.gh-feed.post-feed:not(.gh-featured):not(.gh-related)'

export default function feed() {
  initFeedLightbox()

  const mainGrid = document.querySelector(MAIN_FEED_SELECTOR)
  const featuredGrid = document.querySelector('.post-feed.gh-featured')
  const relatedGrid = document.querySelector('.post-feed.gh-related')

  mainGrid && initGrid(mainGrid, true)
  featuredGrid && initGrid(featuredGrid, false)
  relatedGrid && initGrid(relatedGrid, false)
}

function initGrid(grid, isMainGrid) {
  imagesLoadedWithProgress(grid, function () {
    initMasonry(grid)

    if (isMainGrid) {
      infiniteScroll({
        done: function (params) {
          infiniteScrollCallback(params)
        },
        rootSelector: MAIN_FEED_SELECTOR,
      })
    }
  })
}

function infiniteScrollCallback(params) {
  params = params || {}

  const items = params.items
  const onComplete = params.onComplete
  const featuredFeed = params.featuredFeed
  const imagesToLoad = featuredFeed ? [...items, featuredFeed] : items

  imagesLoadedWithProgress(imagesToLoad, function (loaded) {
    loaded.elements.forEach(function (item) {
      item.style.visibility = 'visible'
      safeResizeMasonryItem(item)
    })

    featuredFeed && initMasonry(featuredFeed)

    onComplete()
  })
}

function initMasonry(grid) {
  function masonry() {
    const items = grid.querySelectorAll('.grid-item')
    items.forEach(safeResizeMasonryItem)
  }

  masonry()

  grid.classList.add('initialized')

  const debouncedResize = debounce(masonry)
  window.addEventListener('resize', debouncedResize)
}

function resizeMasonryItem(item) {
  const grid = item.parentElement
  const content = item.firstElementChild

  if (!content) return

  const rowHeight = parseInt(
    getComputedStyle(grid).getPropertyValue('grid-auto-rows')
  )
  const rowGap = parseInt(getComputedStyle(grid).getPropertyValue('gap'))
  const itemHeight = content.getBoundingClientRect().height
  const rowSpan = Math.ceil((itemHeight + rowGap) / (rowHeight + rowGap))

  item.style.gridRowEnd = `span ${rowSpan}`
  item.classList.add('initialized')
}

function safeResizeMasonryItem(item) {
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      resizeMasonryItem(item)
    })
  })
}

function initFeedLightbox() {
  let gallery = null

  const postLightboxTriggerSelector = '.post-lightbox'
  const postSelector = '.post'
  const postImageSelector = 'img.post-image'
  const allPostImagesSelector = '.post img.post-image'
  const postCaptionSelector = '.post-caption'

  function getCaptionContent(slide) {
    const postEl = slide.data.element.closest(postSelector)
    const captionEl = postEl && postEl.querySelector(postCaptionSelector)

    return captionEl && captionEl.outerHTML
  }

  function clickHandler(e) {
    const lightboxTriggerEl = e.target.closest(postLightboxTriggerSelector)

    if (lightboxTriggerEl) {
      e.preventDefault()

      if (!gallery) {
        gallery = lightbox(allPostImagesSelector, {
          pswpOptions: { counter: false },
          isDynamic: true,
          captionContent: getCaptionContent,
        })
      }

      const postEl = lightboxTriggerEl.closest(postSelector)
      const postImageEl = postEl && postEl.querySelector(postImageSelector)
      const allPostImages = document.querySelectorAll(allPostImagesSelector)
      const index = [...allPostImages].indexOf(postImageEl)

      if (index > -1) {
        gallery.loadAndOpen(index)
      }

      return false
    }
  }

  document.body.addEventListener('click', clickHandler)
}

function imagesLoadedWithProgress(elem, fn) {
  const imgLoaded = imagesLoaded(elem, fn)

  imgLoaded.on('progress', handleImageLoadedProgress)

  return imgLoaded
}

function handleImageLoadedProgress(_instance, image) {
  const className = image.isLoaded ? 'image-loaded' : 'image-error'
  const imgElement = image.img
  imgElement.parentElement && imgElement.parentElement.classList.add(className)
}
